export default {
	"subscribe.CardClick": "卡片点击",
	"subscribe.checkTheDetails": "查看详情",
	"subscribe.subscribing": "订阅中",
	"subscribe.continueToSubscribe": "继续订阅",
	"subscribe.Paused": "已暂停",
	"subscribe.TurnOnRenewal": "开启续费",
	"subscribe.expired": "已失效",
	"subscribe.completed": "已完成",
	"subscribe.ViewDeductionRecords": "查看扣费记录",
	"subscribe.UnfortunatelyNoMatchingDataWasFound": "非常遗憾，没有找到符合条件的数据"
}